export enum ReservationAssignmentStatuses {
  Unassigned = 1,
  Unassigned_Technician = 2,
  Assigned_Template = 90,
  Assigned = 100,
  Assigned_Technician = 200,
}
